import { __, __x, __nx, __N } from 'JIX/gettext.js';

export default {
    header: (companyname) =>
        __x('{companyname} jobannoncestatistik', { companyname }),
    intro: (companyname) =>
        __x('Herunder kan du få et overblik over antal opslåede jobannoncer over tid og se hvilke jobkategorier og områder, som {companyname} har benyttet historisk', { companyname }),
    noAds: () =>
        __('Antal annoncer'),
    ads: () =>
        __('Jobannoncer'),
    previousQuartersLegend: () =>
        __('Annoncer per kvartal'),
    currentQuartersLegend: () =>
        __('Indeværende kvartal'),
    yearlyHeader: () =>
        __('Annoncestatistik'),
    channelHeader: () =>
        __('Jobannoncer fordelt på kanaler'),
    areaHeader: () =>
        __('Jobannoncer fordelt på områder'),
    editPeriod: () =>
        __('Rediger viste periode'),
};
